import moment from 'moment'

export default () => ({
  collection: [],
  isLoading: false,
  isLoadingError: false,
  activePreset: 'last',
  form: {
    searchValue: '',
    statuses: [],
    payments: [],
    types: [],
    dateFrom: moment().subtract(3, 'months').format('DD.MM.YYYY'),
    dateTo: moment().format('DD.MM.YYYY'),
    filterDate: 'createDate',
    onlyUpdates: false,
    sortBy: 'createDate',
    sortDirection: 'ASC'
  },
  formErrors: [],
  dictionaries: {
    currencies: []
  },
  pagination: {
    page: 1,
    perPage: 10,
    lastPage: 1,
    total: 10
  },
  includes: {
    services: {},
    statuses: {}
  },
})